import { useEffect, useRef, useState } from 'react';

export function useOverflowHint<T extends HTMLElement>() {
  const ref = useRef<T | null>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isAtEnd, setIsAtEnd] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const update = () => {
      const overflow = el.scrollWidth > el.clientWidth;
      setIsOverflowing(overflow);
      if (overflow) {
        const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
        setIsAtEnd(atEnd);
      } else {
        setIsAtEnd(false);
      }
    };

    update();

    const ro = new ResizeObserver(update);
    ro.observe(el);

    const onScroll = () => update();
    el.addEventListener('scroll', onScroll, { passive: true });

    window.addEventListener('resize', update);

    return () => {
      ro.disconnect();
      el.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', update);
    };
  }, []);

  return { ref, isOverflowing, isAtEnd };
}
